import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/top.png'
import _imports_1 from '@/assets/images/icon/close-red2.png'


const _hoisted_1 = { class: "contact-us" }
const _hoisted_2 = {
  key: 0,
  class: "contact-model"
}

import { ref, onMounted, reactive } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { addConsult } from '@/api'
import { ElMessage } from "element-plus";
import DropDown from '@/components/DropDown.vue'
import { asynchronousRetrieval } from '@/utils'
interface RuleForm {
  name: string
  companyName: string
  phone: string
  message: string
  consultType: any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

const loadUrl: any = ref({})

const data = ref([
  {
    name: '硬件品牌方',
    value: 1
  },
  {
    name: '渠道端/零售终端',
    value: 2
  },
  {
    name: 'B/G端需求方',
    value: 3
  },
  {
    name: '其它',
    value: 4
  },
])
const ruleFormRef = ref<FormInstance>()
const ruleForm: any = reactive<RuleForm>({
  name: '',
  companyName: '',
  phone: '',
  message: '',
  consultType: null
})

const verifyPhoneNumber = (rule: any, value: any, callback: any) => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  if (!reg.test(value.replace(/\s+/g, ""))) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

const rules = reactive<FormRules<RuleForm>>({
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  companyName: [
    { required: true, message: '请输入公司名', trigger: 'blur', }
  ],
  phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: verifyPhoneNumber, trigger: 'blur' }],
  consultType: [{ required: true, message: '请选择伙伴类型', trigger: 'blur', }],
})

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      addConsult({ ...ruleForm, appId: 1 }).then((res) => {
        ElMessage({
          message: '感谢您的反馈!',
          type: "success",
          duration: 2000,
        })
        showModel.value = false
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

const showContact = ref('')
const showModel = ref(false)
const toTop = () => {
  window.scrollTo(0, 0)
}

onMounted(async() => {
  //
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(showContact.value)
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("div", null, "咨询电话"),
          _createElementVNode("div", null, "400-900-6269")
        ], -1)),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"color":"#333"} }, "咨询表单", -1)),
          _createElementVNode("div", {
            style: {"cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModel.value = true))
          }, "点击填写")
        ])
      ], 2),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showContact.value = (showContact.value ? '' : 'show-contact')))
        }, "联系我们"),
        _createElementVNode("div", { onClick: toTop }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1)
        ]))])
      ])
    ]),
    (showModel.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "form-content",
            onClick: _withModifiers(($event: any) => (null), ["stop"])
          }, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showModel.value = false), ["stop"]))
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("img", { src: _imports_1 }, null, -1)
            ]))]),
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: ruleForm,
              rules: rules,
              "require-asterisk-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "伙伴类型",
                  prop: "consultType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: ruleForm.consultType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.consultType) = $event)),
                      placeholder: "请选择资源类型",
                      class: "select-default",
                      "popper-class": "select-option",
                      "suffix-icon": DropDown
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  style: {"margin-top":"20rem"},
                  label: "姓名",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: ruleForm.name,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.name) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司名称",
                  prop: "companyName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: ruleForm.companyName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.companyName) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "电话",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: ruleForm.phone,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.phone) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "留言",
                  prop: "message"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      type: "textarea",
                      modelValue: ruleForm.message,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.message) = $event)),
                      placeholder: "请输入",
                      resize: "none"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { class: "form-submit" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "btn-primary",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (submitForm(ruleFormRef.value)))
                    }, " 提交 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})